// src/components/Room/CopySpaceModeBanner.tsx
import React from "react";
import { ActionIcon, Alert, Group, Text } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { FaInfoCircle } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import { clearDesignThunk } from "./designThunk";

export const CopySpaceModeBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const copySpaceMode = useAppSelector((s) => s.design.copySpaceModeActive);

  if (!copySpaceMode) return null;

  return (
    <Alert
      variant="light"
      color="blue"
      radius="xl"
      icon={<FaInfoCircle size={16} />}
      styles={{
        root: {
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 14,
          paddingRight: 10,
          backgroundColor: "var(--mantine-color-blue-1)", // tydligare bakgrund
          border: "1px solid var(--mantine-color-blue-4)", // djupare kant
          boxShadow: "0 4px 18px rgba(0,0,0,0.18)", // separation från bakgrund
        },
      }}
    >
      <Group justify="space-between" align="center" wrap="nowrap">
        <div>
          <Text size="sm" fw={600} c="black">
            Kopieringsmodus er aktiv
          </Text>
          <Text size="xs" c="dimmed">
            Klikk på de rommene du vil kopiere til i modellen.
          </Text>
        </div>

        <ActionIcon
          variant="subtle"
          color="blue"
          radius="xl"
          aria-label="Avslutt kopieringsmodus"
          onClick={() => dispatch(clearDesignThunk())}
        >
          <FaXmark size={14} />
        </ActionIcon>
      </Group>
    </Alert>
  );
};
